export default {
    FIXA: 1,
    DINAMICA: 2
}